// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","heading":"Header_heading__O065u"};